import React from 'react';
import ContactForm from '../components/ContactForm';

const ContactPage: React.FC = () => {
  return (
    <div className="pt-16">
      <div className="bg-white text-[#2b603e] py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold mb-4">Contact Us</h1>
          <p className="text-xl max-w-3xl mx-auto text-[#2b603e]/80">
            Have questions or feedback? We're here to support your wellness journey.
          </p>
        </div>
      </div>

      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12">
            <div className="bg-white rounded-xl shadow-2xl p-10 border border-[#2b603e]/10">
              <h2 className="text-3xl font-bold text-[#2b603e] mb-6 pb-2 border-b-4 border-[#2b603e] inline-block">Contact Information</h2>
              
              <div className="space-y-6">
                <div className="flex items-center space-x-4">
                  <div className="w-16 h-16 bg-[#2b603e]/10 rounded-full flex items-center justify-center">
                    <svg className="w-8 h-8 text-[#2b603e]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#2b603e] text-left">Address</h3>
                    <p className="text-gray-600 text-left">The Netherlands, Rotterdam De Damhouderstraat 41 3052NH, <br/> <strong>KVK Number</strong>: 97472875</p>
                  </div>
                </div>
                
                <div className="flex items-center space-x-4">
                  <div className="w-16 h-16 bg-[#2b603e]/10 rounded-full flex items-center justify-center">
                    <svg className="w-8 h-8 text-[#2b603e]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#2b603e] text-left">Phone</h3>
                    <p className="text-gray-600 text-left">+31 657945978</p>
                  </div>
                </div>

                <div className="flex items-center space-x-4">
                  <div className="w-16 h-16 bg-[#2b603e]/10 rounded-full flex items-center justify-center">
                    <svg className="w-8 h-8 text-[#2b603e]" fill="currentColor" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                      <path d="M16 0C7.164 0 0 7.163 0 16c0 2.82.735 5.451 2.018 7.744L0 32l8.441-2.165A15.93 15.93 0 0 0 16 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm0 29.333a13.262 13.262 0 0 1-6.84-1.864l-.491-.294-5.002 1.282 1.313-4.872-.318-.502a13.231 13.231 0 0 1-2.036-7.078c0-7.346 5.98-13.333 13.333-13.333S29.333 8.654 29.333 16 23.354 29.333 16 29.333zm7.247-9.349c-.392-.196-2.32-1.144-2.68-1.276-.36-.132-.622-.196-.884.196s-1.014 1.276-1.244 1.54-.456.294-.848.098c-.392-.196-1.654-.608-3.153-1.938-1.164-1.038-1.947-2.316-2.173-2.708s-.024-.602.172-.797c.176-.175.392-.456.588-.68.196-.224.26-.392.392-.653.132-.261.065-.49-.033-.685-.098-.196-.884-2.132-1.213-2.92-.32-.768-.648-.66-.884-.673l-.752-.014c-.261 0-.685.098-1.042.49s-1.37 1.337-1.37 3.26 1.402 3.78 1.596 4.038c.196.26 2.768 4.22 6.71 5.921 2.484 1.07 3.448 1.163 4.692.98 1.096-.164 2.32-.948 2.646-1.863.327-.915.327-1.7.229-1.863-.098-.163-.36-.26-.752-.456z"/>
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#2b603e] text-left">WhatsApp</h3>
                    <p className="text-gray-600 text-left">+31 657945978</p>
                  </div>
                </div>
                
                <div className="flex items-center space-x-4">
                  <div className="w-16 h-16 bg-[#2b603e]/10 rounded-full flex items-center justify-center">
                    <svg className="w-8 h-8 text-[#2b603e]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#2b603e] text-left">Email</h3>
                    <p className="text-gray-600 text-left">info@asclepius-shilajit.com</p>
                  </div>
                </div>
                
                <div className="flex items-center space-x-4">
                  <div className="w-16 h-16 bg-[#2b603e]/10 rounded-full flex items-center justify-center">
                    <svg className="w-8 h-8 text-[#2b603e]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#2b603e] text-left">Business Hours</h3>
                    <p className="text-gray-600 text-left">
                      Mon-Fri: 9:00 AM - 6:00 PM<br />
                      Sat: 10:00 AM - 4:00 PM<br />
                      Sun: Closed
                    </p>
                  </div>
                </div>
              </div>
            </div>
            
            <div>
              <ContactForm />
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-[#2b603e] mb-4 pb-2 border-b-4 border-[#2b603e] inline-block">Frequently Asked Questions</h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Find quick answers to common questions about our products and services.
            </p>
          </div>

          <div className="max-w-3xl mx-auto space-y-4">
            <div className="border border-[#2b603e]/20 rounded-lg overflow-hidden">
              <div 
                className="px-6 py-4 bg-[#2b603e]/5 flex justify-between items-center cursor-pointer hover:bg-[#2b603e]/10 transition-colors"
                onClick={(e) => {
                  const nextSibling = e.currentTarget.nextElementSibling;
                  nextSibling?.classList.toggle('hidden');
                }}
              >
                <h3 className="text-lg font-semibold text-[#2b603e]">
                  What makes Asclepius Shilajit unique?
                </h3>
                <svg 
                  className="w-5 h-5 text-[#2b603e]" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24" 
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                </svg>
              </div>
              <div className="px-6 py-4 text-gray-600 border-t border-[#2b603e]/20 hidden">
                Our Shilajit is sourced directly from the pristine Himalayan mountains, carefully extracted using traditional methods. We work closely with local communities to ensure the highest quality, purity, and sustainability. Each batch is rigorously tested and processed to maintain its natural potency.
              </div>
            </div>

            <div className="border border-[#2b603e]/20 rounded-lg overflow-hidden">
              <div 
                className="px-6 py-4 bg-[#2b603e]/5 flex justify-between items-center cursor-pointer hover:bg-[#2b603e]/10 transition-colors"
                onClick={(e) => {
                  const nextSibling = e.currentTarget.nextElementSibling;
                  nextSibling?.classList.toggle('hidden');
                }}
              >
                <h3 className="text-lg font-semibold text-[#2b603e]">
                  What are the main benefits?
                </h3>
                <svg 
                  className="w-5 h-5 text-[#2b603e]" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24" 
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                </svg>
              </div>
              <div className="px-6 py-4 text-gray-600 border-t border-[#2b603e]/20 hidden">
                Shilajit is a natural mineral-rich resin traditionally used to support overall wellness and vitality. It contains fulvic acid and trace minerals, naturally occurring components found in this resin.
              </div>
            </div>

            <div className="border border-[#2b603e]/20 rounded-lg overflow-hidden">
              <div 
                className="px-6 py-4 bg-[#2b603e]/5 flex justify-between items-center cursor-pointer hover:bg-[#2b603e]/10 transition-colors"
                onClick={(e) => {
                  const nextSibling = e.currentTarget.nextElementSibling;
                  nextSibling?.classList.toggle('hidden');
                }}
              >
                <h3 className="text-lg font-semibold text-[#2b603e]">
                  How long until I notice benefits?
                </h3>
                <svg 
                  className="w-5 h-5 text-[#2b603e]" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24" 
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                </svg>
              </div>
              <div className="px-6 py-4 text-gray-600 border-t border-[#2b603e]/20 hidden">
                Results vary per individual. Some users notice subtle changes in daily energy or focus after a few weeks of consistent use.
              </div>
            </div>

            <div className="border border-[#2b603e]/20 rounded-lg overflow-hidden">
              <div 
                className="px-6 py-4 bg-[#2b603e]/5 flex justify-between items-center cursor-pointer hover:bg-[#2b603e]/10 transition-colors"
                onClick={(e) => {
                  const nextSibling = e.currentTarget.nextElementSibling;
                  nextSibling?.classList.toggle('hidden');
                }}
              >
                <h3 className="text-lg font-semibold text-[#2b603e]">
                  Do you offer international shipping?
                </h3>
                <svg 
                  className="w-5 h-5 text-[#2b603e]" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24" 
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                </svg>
              </div>
              <div className="px-6 py-4 text-gray-600 border-t border-[#2b603e]/20 hidden">
                Yes, we ship to most countries worldwide. International shipping rates and delivery times vary depending on the destination. Customers are responsible for any customs duties or taxes that may apply. You can find more details in our Shipping Policy.
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;